import React from 'react';
import {cs}   from "@Common/react/chain-services";
import {Link} from 'react-router-dom';
import {Chip} from '@Common/ui-components/heavy/common/design2/chip/chip';
import "./omni-search-tabs.scss";
import {consumeContext} from '@Common/react/context';
import {UseState} from '@Common/react/use-state';
import {removeListingParams} from '@Xpresso/routes/listing-params';
import {ROUTE_OMNISEARCH} from "@Xpresso/routes/omni-search/omni-search-route";

export const OmniSearchTabs = ({queryParam, listSelected, setListSelected, mailingOnly, setMailingOnly}) => {
    const pathname = window.location.pathname
    const shouldShowTabs = pathname.includes(ROUTE_OMNISEARCH.BROWSE) || pathname.includes(ROUTE_OMNISEARCH.EXPLORE)

    const text = headerText(queryParam)
    
    return (
        <div>
            <header className="header-with-tabs-235711">
                <div className="header-container">
                    <HeaderText {...{text}}/>
                    <ChipContainer {...{listSelected, setListSelected, mailingOnly, setMailingOnly}}/>
                </div>
                {
                    shouldShowTabs &&
                    <TabList>
                        <Tab {...{
                            text: "Explore",
                            to: `explore${persistentSearchQuery(queryParam, [])}`,
                            selected: pathname.includes(ROUTE_OMNISEARCH.EXPLORE),
                        }}/>
                        <Tab {...{
                            text: "Products & Templates",
                            to: `browse${persistentSearchQuery(queryParam, ['p'])}`,
                            selected: pathname.includes(ROUTE_OMNISEARCH.BROWSE),
                        }}/>
                    </TabList>
                }
            </header>
        </div>
    )
}

const HeaderText = ({text}:{text:string}) => (
    <div className="header-text-235711" xd-qa-type="label" xd-qa-name={text}>
        {text}
    </div>
)

const ChipContainer = ({listSelected, setListSelected, mailingOnly, setMailingOnly}) => cs(
    consumeContext("apis"),
    consumeContext("userLevels"),
    consumeContext("themeScheme"),
    ({apis, userLevels, themeScheme}) => {
        return (
            (listSelected || userLevels?.listSelected) && <div className="chip-235712">
                <span className="subtext">Showing Results in</span>
                {listSelected == true && (
                    <Chip
                        backgroundColor={themeScheme?.xpresso.menuBackgroundColor}
                        textColor={themeScheme?.xpresso.menuTextColor}
                        text={`Listing Selected: ${sessionStorage.getItem("listingStreetAddress")}`}
                        onClose={() => {
                            removeListingParams();
                            setListSelected(0);
                        }}
                    />
                )}
                {mailingOnly == true && (
                    <Chip
                        backgroundColor={themeScheme?.xpresso.menuBackgroundColor}
                        textColor={themeScheme?.xpresso.menuTextColor}
                        text={`Showing Mailing Templates`}
                        onClose={() => {
                            sessionStorage.removeItem("mailingOnly");
                            setMailingOnly(false);
                        }}
                    />
                )}
                {userLevels?.listSelected && (
                    <Chip
                        backgroundColor={themeScheme?.xpresso.menuBackgroundColor}
                        textColor={themeScheme?.xpresso.menuTextColor}
                        text={`Recipient List Selected: ${userLevels.listName}`}
                        onClose={async () => {
                            await apis.next.session.clearSessionOrder();
                            userLevels.reload();
                        }}
                    />
                )}
            </div>
        )
    }
)
const HeaderWithTabs = ({
    text, children, listSelected, setListSelected, mailingOnly, setMailingOnly
}:{
    text:string, children:React.ReactNode, listSelected:number, setListSelected, mailingOnly:boolean, setMailingOnly
}) => (
    <div>
        <header className="header-with-tabs-235711">
            <div className="header-container">
                <HeaderText text={text}/>
                <ChipContainer {...{listSelected, setListSelected, mailingOnly, setMailingOnly}}/>
            </div>
            {children}
        </header>
    </div>
)

const Tab = ({text, to, selected=false}:{text:string, to:string, selected?:boolean}) => (
    <Link {...{
        className:`tab-235711${selected ? ' selected' : ''}`,
        to,
        "xd-qa-type": "tab",
        "xd-qa-name": text,
    }}>
        {text}
    </Link>
)

const TabList = ({children}:{children:React.ReactNode}) => (
    <div className="tab-list-235711">
        {children}
    </div>
)

const persistentSearchQuery = (query, preserve = []) => {
    const params = new URLSearchParams(window.location.search)
    const updatedParams = new URLSearchParams()

    if(query) {
        updatedParams.set('q', query)
    }

    preserve.forEach(key => {
        if(key !== 'q' && params.has(key)) {
            updatedParams.set(key, params.get(key)!)
        }
    })

    return `?${updatedParams.toString()}`
}

const headerText = (queryParam) => {
    const params = new URLSearchParams(window.location.search)
    const p = params.get('p')
    if(p) {
        return p.replace(/\b\w|(?<=-)\w/g, (match) => match.toUpperCase())
    }
    if(!queryParam) {
        return ""
    }
    return `"${queryParam}"`
   
}